export default "__VITE_ASSET__C6aQH66C__"